import React, { Component } from 'react';
import { HashRouter  as Router, Route, Link,Redirect } from "react-router-dom";
import { enquireScreen } from 'enquire-js';
import Header from './Layout/Nav0';
import Footer from './Layout/Footer1';
import Home from './Home';
import AboutUs from './AboutUs';
import Service from './Service';
import Rczp from './rczp';
import Fangan from './fangan'
import Dongtai from "./dongtai/index-"
import solutionList from "./solutionList"
import solutionDetail from "./solutionDetail"
import Detail from "./Detail"
import { BackTop,Popover } from 'antd';
import {
  Nav00DataSource,
  Footer10DataSource,
} from './Layout/data.source.js';
import './App.css';
let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const style = {
  height: 60,
  width: 60,
  lineHeight: '60px',
  borderRadius: 4,
  backgroundColor: '#ffffff',
  color: '#2590f2',
  boxShadow:'0 2px 4px rgba(0, 0, 0, .32), 0 0 6px rgba(0, 0, 0, .24)',
  textAlign: 'center',
  fontSize: 18,
};

var telephoneContent = (
  <div style={{width:'190px'}}>
    <p>联系电话：0792-8159222</p>
    <p>联系电话：17770299988</p>
    <p>公司地址：江西省九江市濂溪区十里老街C4栋4层1499号</p>
  </div>
)

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isMobile,
    };
  }
  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
  }

    
  abc=(e)=>{
    if (e.indexOf('?')!=-1) {
      return e.replace('?', '');      
    }
    return e
  }



  render() {

    return (
      <Router>
        <div>
          <BackTop>
            <div style={style}>
              <div style={{fontSize:'18px'}}>↑</div>
            </div>
          </BackTop>
          <Popover content={telephoneContent} title="联系我们">
             <div className="share-wrapper">
                <div className="share-wrapper-image" style={{width:'40px',height:'40px',backgroundColor:'#2590f2',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',color:'white'}}>📞</div>
              </div>
          </Popover>
          <Header dataSource={Nav00DataSource} isMobile={this.isMobile} />
          <Route exact path="/" component={Home} />
          <Route exact path="/about-us" component={AboutUs} />
          <Route exact path="/service" component={Service} />
          <Route exact path="/rczp" component={Rczp} />
          <Route exact path="/fangan" component={Fangan} />
          <Route exact path="/dongtai" component={Dongtai} />
          <Route exact path="/solution-list" component={solutionList} />
          <Route exact path="/a-detail" render={props=>(
                <Redirect  to={{ pathname: '/detail',search:JSON.stringify(this.abc((props.location.search)))}} />
          )}> 
          </Route>

          <Route exact path="/a-solution-detail" render={props=>(
                <Redirect  to={{ pathname: '/solution-detail',search:JSON.stringify(this.abc((props.location.search)))}} />
          )}> 
          </Route>
          
          <Route exact path="/solution-detail" component={solutionDetail} />
          <Route exact path="/detail" component={Detail} />
          
          <Footer dataSource={Footer10DataSource} isMobile={this.isMobile} />
        </div>
      </Router>
    );
  }
}

export default App;